import { mPerLat, mPerLon } from './geo';
// street view geometry: bearing/destination/perspective projection of ground points
const rad = Math.PI / 180;
const kx = (lat) => mPerLon(lat);
export const norm180 = (x) => ((((x + 180) % 360) + 360) % 360) - 180;
export const norm360 = (x) => ((x % 360) + 360) % 360;
export const svDist = (a, b) => Math.hypot((b[1] - a[1]) * kx(a[0]), (b[0] - a[0]) * mPerLat(a[0]));
export const svBearing = (a, b) => norm360(Math.atan2((b[1] - a[1]) * kx(a[0]), (b[0] - a[0]) * mPerLat(a[0])) / rad);
export const svDest = (a, brg, d) => [a[0] + (d * Math.cos(brg * rad)) / mPerLat(a[0]), a[1] + (d * Math.sin(brg * rad)) / kx(a[0])];

export const SV_HFOV = 90;
export const SV_CAM_H = 2.5;
// ground point -> screen px (pitch 0), null if behind/outside
export function svProject(cam, heading, p, W, H) {
  const d = svDist(cam, p), rel = norm180(svBearing(cam, p) - heading);
  const z = d * Math.cos(rel * rad);
  if (Math.abs(rel) >= 85 || z < 0.4) return null;
  const f = W / 2 / Math.tan((SV_HFOV / 2) * rad);
  return { x: W / 2 + (f * d * Math.sin(rel * rad)) / z, y: H / 2 + (f * SV_CAM_H) / z, d, rel };
}

// densify a polyline (~1 m steps) and keep only points within r metres of cam
export function svSample(cam, pts, r = 50) {
  const out = [];
  for (let i = 0; i < pts.length - 1; i++) {
    const a = pts[i], b = pts[i + 1], n = Math.max(1, Math.ceil(svDist(a, b)));
    for (let k = 0; k <= n; k++) {
      const p = [a[0] + ((b[0] - a[0]) * k) / n, a[1] + ((b[1] - a[1]) * k) / n];
      out.push(svDist(cam, p) <= r ? p : null);
    }
  }
  return out;
}

export const streetViewEmbedH = (lat, lon, h) => `https://www.google.com/maps/embed?origin=mfe&pb=!6m7!1m6!2m2!1d${lat}!2d${lon}!3f${Math.round(h)}!4f0!5f1`;
